import type { UseLocalStorageReducerDispatch } from "@dealer-center/core-components";
import { List, ListItem } from "@dealer-center/core-components";
import { AccountSearchListItem } from "./AccountSearchListItem";
import styled from "styled-components";
import type { dealerSearchIncoming } from "@dealer-center/ddc-pages-account-search-interface";

const StyledListContainerWrapper = styled.div`
  .list-container__header-title {
    height: 36px;
    padding-bottom: 4px;
    margin: 0;
    font-size: 16px;
  }
`;
export function AccountSearchList({
  searches,
  onDelete,
  title,
  dispatchAccountSearchHistory,
  accountSearchFavoritesPersisted
}: {
  searches: dealerSearchIncoming[];
  onDelete?: (search: dealerSearchIncoming) => void;
  title: string;
  dispatchAccountSearchHistory: UseLocalStorageReducerDispatch<dealerSearchIncoming>;
  accountSearchFavoritesPersisted: [
    dealerSearchIncoming[],
    UseLocalStorageReducerDispatch<dealerSearchIncoming>
  ];
}) {
  const [accountSearchFavorites, dispatchAccountSearchFavorites] =
    accountSearchFavoritesPersisted;
  const htmlIdSafeTitle = title.replace(/\s/g, "-");
  const isFavourite = (search: dealerSearchIncoming) => {
    return accountSearchFavorites.some(favourite => {
      return JSON.stringify(favourite) === JSON.stringify(search);
    });
  };

  return (
    <StyledListContainerWrapper>
      <h2>{title}</h2>
      {searches && searches.length > 0 && (
        <List>
          {searches.map((search, i) => {
            return (
              <ListItem
                // eslint-disable-next-line react/no-array-index-key
                key={`${htmlIdSafeTitle}-AccountList-item-${i}`}
                sx={{
                  border: 0,
                  margin: 0,
                  padding: 0
                }}
              >
                <AccountSearchListItem
                  account={search}
                  dispatchAccountSearchFavorites={
                    dispatchAccountSearchFavorites
                  }
                  dispatchAccountSearchHistory={dispatchAccountSearchHistory}
                  isFavourite={isFavourite(search)}
                  onDelete={onDelete}
                />
              </ListItem>
            );
          })}
        </List>
      )}
    </StyledListContainerWrapper>
  );
}
